export const LOGIN = "login";
export const VERIFY_EMAIL = "verifyEmail";
export const FORGOT_PASSWORD = "forgetPassword";
export const CHANGE_PASSWORD = "resetPassword";
export const VIEW_PROFILE = "viewProfile";
export const EDIT_PROFILE = "editProfile";

export const EDIT_PROFILE_API = "/editProfile";

// common
export const LISTOFCOUNTRY = "listOfCountry";
export const LISTOFSTATE = "listOfState";
export const LISTOFCITY = "listOfCity";
export const LISTOFBANK = "listOfBank";
export const GET_VENDOR_LIST = "getVendorList";
export const FILEUPLOAD = "fileUploads";
export const MATERIALLIST = "getMaterialList";
export const MATERIALGROUP = "getMaterialGroupList";
export const MANUFACTURERLIST = "getManufacturerList";
export const GET_USER_PERMISSION = "getUserPermission/";
export const GET_PROJECT_LIST = "getProjectList";
export const GET_CUSTOMER_LIST = "getCustomerList";
export const WORK_ORDER_DATA = "work-order/getWorkOrderQuotation";

// Permission/Role
export const LISTOFPOSITIONFORSELECT = "permission/getPositionList";
export const CREATEPOSITION = "permission/createPosition";
export const UPDATEPOSITION = "permission/updatePosition/";
export const VIEWPOSITION = "permission/viewPosition/";
export const LISTPOSITION = "permission/listOfPosition";
export const UPDATEPOSITIONSTATUS = "permission/updatePositionStatus/";
export const DELETEPOSITION = "permission/deletePosition/";
export const LISTOFPERMISSIONS = "permission/listOfPermission";
// staff
export const CREATESTAFF = "staff/createStaff";
export const VIEWSTAFF = "staff/viewStaff/";
export const UPDATESTAFF = "staff/updateStaff/";
export const DELETESTAFF = "staff/deleteStaff/";
export const LISTOFSTAFF = "staff/listOfStaff";
export const UPDATESTATUSSTAFF = "staff/updateStaffStatus/";

// Service
export const CREATESERVICE = "service/addService";
export const VIEWSERVICE = "service/viewService/";
export const EDITSERVICE = "service/editService";
export const DELETESERVICE = "service/deleteService/";
export const LISTOFSERVICE = "service/listOfService";
export const COUNT_SERVICE_GST = "service/countGstAmount";

// HsnSac
export const CREATEHSN = "hsn-sac/addHsnSac";
export const VIEWHSN = "hsn-sac/viewHsnSac/";
export const EDITHSN = "hsn-sac/editHsnSac";
export const DELETEHSN = "hsn-sac/deleteHsnSac/";
export const LISTOFHSN = "hsn-sac/listOfHsnSac";

// RepairOrderOpen
export const CREATEROO = "repair-order/addRepairOrder";
export const VIEWROO = "repair-order/viewRepairOrder";
export const EDITROO = "repair-order/editRepairOrder";
export const DELETEROO = "repair-order/deleteRepairOrder/";
export const LISTOFROO = "repair-order/listOfRepairOrder";
export const GET_QUOTATION_LIST = "repair-order/listOfQuotationNo";
export const GET_WORK_ORDER_LIST = "repair-order/listOfWorkOrderNo";

// RO Number Drop Down
export const RO_NUMBER_LIST = "repair-order/listOfRepairOrderNo";
export const PO_NUMBER_LIST = "po-return/listOfPurchaseOrderNo";
export const RECIEVED_PO_LIST = "po-return/listOfReceivedStatus";

// PartIssueDetails

export const CREATEPID = "part-issue/addOrEditPartIssue";
export const VIEWPID = "part-issue/viewPartIssue";
export const LISTOFPID = "part-issue/listOfPartIssue";
export const HISTORY_OF_PID = "part-issue/historyOfPartIssue";

//Part Requisition
export const LISTOFPR = "part-requisition/listOfPartRequisition";
export const VIEWPR = "part-requisition/viewPartRequisition";
export const VIEWPRWORO = "part-requisition/viewPartRequisitionWithoutRO";
export const LISTOFITEMCODE = "part-requisition/listOfItemCode";
export const LISTOFPRODUCTSFORITEM = "part-requisition/listOfProduct";
export const LISTOFPROJECT = "part-requisition/listOfProject";
export const ADDOREDITPR = "part-requisition/addOrEditPartRequisition";
export const EDITPRWORO = "part-requisition/editPartRequisitionWithoutRO";
export const DELETEPR = "part-requisition/deletePartRequisition";

//Purchase Order with RO
export const ADDPOWITHRO = "ro-purchase-order/createPurchaseOrder";
export const VIEWPRWITHRO = "ro-purchase-order/viewPurchaseOrder";
export const VIEWPOWORO = "ro-purchase-order/viewPurchaseOrderWithoutRO";
export const LISTOFPO = "ro-purchase-order/listOfPurchaseOrder";
export const DELETEPOWITHRO = "ro-purchase-order/deletePurchaseOrder/";
export const UPDATEPOWITHRO = "ro-purchase-order/updatePurchaseOrder";
export const UPDATEPOSTATUS = "ro-purchase-order/updateStatus/";

//Repair Order Close
export const ROCLOSE = "part-issue/repairOrderClose";
export const VIEW_ROC = "part-issue/viewRepairOrderClose";

//listOfClose RO
export const CLOSED_RO = "part-issue/listOfClosedRepairOrder";

//RO Return
export const ADD_RETURN_RO = "return_repair-order/addRepairOrderReturn";
export const EDIT_RETURN_RO = "return_repair-order/editRepairOrderReturn";
export const LIST_OF_RETURN_RO =
  "return_repair-order/listOfMainRepairOrderReturn";
export const DELETE_RETURN_RO = "return_repair-order/deleteRepairOrderReturn/";
export const RO_RETURN_HISTORY =
  "return_repair-order/historyOfRepairOrderReturn";
export const UPDATE_RO_RETURN_STATUS = "return_repair-order/updateStatus/";
export const VIEW_RO_RETURN = "return_repair-order/viewOfRepairOrderReturn";
export const VIEW_SINGLE_RO_RETURN =
  "return_repair-order/viewSingleRepairOrderReturn";

//POreturn
export const ADD_RETURN_PO = "po-return/addPurchaseOrderReturn";
export const EDIT_RETURN_PO = "po-return/editPurchaseOrderReturn";
export const LIST_OF_RETURN_PO = "po-return/listOfPurchaseOrderReturn";
export const PO_RETURN_HISTORY = "po-return/historyOfPurchaseOrderReturn";
export const DELETE_RETURN_PO = "po-return/deletePurchaseOrderReturn/";
export const UPDATE_PO_RETURN_STATUS = "po-return/updateStatus/";
export const VIEW_PO_RETURN = "po-return/viewOfPurchaseOrderReturn";
export const VIEW_SINGLE_PO_RETURN = "po-return/viewSinglePurchaseOrderReturn";

//Reopen RO
export const REOPEN_RO = "part-issue/repairOrderReopen";

// staff
export const CREATECUSTOMER = "staff/createCustomer";
export const VIEWCUSTOMER = "staff/viewUser/";
export const UPDATECUSTOMER = "staff/updateCustomer/";
export const DELETECUSTOMER = "staff/deleteCustomer/";
export const LISTOFCUSTOMER = "staff/listOfCustomer";

//material
export const CREATE_MATERIAL = "material";
export const LIST_OF_MATERIAL = "material/list";
export const MATERIAL = "material/";

//material group
export const CREATE_MATERIAL_GROUP = "material-group";
export const LIST_OF_MATERIAL_GROUP = "material-group/list";
export const MATERIAL_GROUP = "material-group/";

//manufacturer
export const CREATE_MANUFACTURER = "manufacturer";
export const LIST_OF_MANUFACTURER = "manufacturer/list";
export const MANUFACTURER = "manufacturer/";
//project
export const CREATE_PROJECT = "project";
export const LIST_OF_PROJECT = "project/list";
export const PROJECT = "project/";

//product
export const LISTOFPRODUCT = "product/listOfProduct";
export const CREATEPRODUCT = "product/createProduct/";
export const UPDATEPRODUCT = "product/updateProduct/";
export const DELETEPRODUCT = "product/deleteProduct/";
export const VIEWPRODUCT = "product/viewProduct/";
export const IMPORT_PRODUCT = "report/generateProductReport";
export const IMPORT_PRODUCT_DATA = "product/importProductData";

// Purchase Order
export const LIST_OF_PRODUCT_DROPDOWN = "getProductList";
export const CREATE_INDENT = "indent/createIndent";
export const UPDATE_INDENT = "indent/updateIndent/";
export const VIEW_INDENT = "indent/viewIndent/";
export const DELETE_INDENT = "part-requisition/deletePartRequisitionWithoutRO/";
export const LIST_OF_INDENT = "part-requisition/listOfPartRequisition";
export const CREATE_PURCHASE_ORDER = "createPurchaseOrder";
export const UPDATE_PURCHASE_ORDER = "updatePurchaseOrder/";
export const VIEW_PURCHASE_ORDER = "viewPurchaseOrder/";
export const VIEW_PURCHASE_ORDER_WO_RO =
  "ro-purchase-order/viewPurchaseOrderWithoutRO/";
export const DELETE_PURCHASE_ORDER = "deletePurchaseOrder/";
export const DELETE_PURCHASE_ORDER_ITEM = "deletePurchaseOrderItem/";
export const LIST_OF_PURCHASE_ORDER =
  "ro-purchase-order/listOfPurchaseOrderWithoutRO";
export const CREATE_GRN = "/ro-purchase-order/createGrn/";
export const PURCHASE_ORDER_PAYMENT = "purchaseOrderPayment/";
export const VIEW_PURCHASE_ORDER_PAYMENT_HISTORY = "viewPoPaymentHistory/";
export const ADD_GRN_HISTORY = "ro-purchase-order/addGrnHistory/";
export const LISTOFRATE = "listOfRate";
export const ADDRATE = "createRate";
export const LISTOFSTOCK = "listOfStock";

// vendor
export const CREATE_VENDOR = "staff/createVendor";
export const VIEW_VENDOR = "staff/viewVendor/";
export const UPDATE_VENDOR = "staff/updateVendor/";
export const DELETE_VENDOR = "staff/deleteVendor/";
export const LIST_OF_VENDOR = "staff/listOfVendor";

// vendor
export const CREATE_TECHNICIAN = "technician/createTechnician";
export const VIEW_TECHNICIAN = "technician/viewTechnician/";
export const UPDATE_TECHNICIAN = "technician/updateTechnician/";
export const DELETE_TECHNICIAN = "technician/deleteTechnician/";
export const LIST_OF_TECHNICIAN = "technician/listOfTechnician";
export const GET_EXPERTISE_LIST = "getExpertiseList";

// order
export const CREATE_ORDER = "order/createOrder";
export const VIEW_ORDER = "order/viewOrder/";
export const LIST_OF_ORDER = "order/listOfOrder";
export const ORDER_PAYMENT = "order/orderPayment/";
export const VIEW_ORDER_HISTORY = "order/viewOrderHistory/";
export const UPDATE_ORDER_HISTORY = "order/updateOrderHistory/";
export const ORDER_REFUND = "order/orderRefund";
export const ADD_TRANSPORT_DETAILS = "order/orderTransaction/";
export const VIEW_TRANSPORT_DETAILS = "order/viewOrderTransaction/";
//job-card

export const JOB_CARD_LIST = "job-card/list";
export const CREATE_JOB_CARD = "job-card";
export const UPDATE_JOB_CARD = "job-card/";
export const DELETE_JOB_CARD = "job-card/delete/";
export const VIEW_JOB_CARD = "job-card/";
export const LIST_JOB_CARDS = "job-card/list";
export const GET_PRODUCT_LIST = "/getProductList";
export const GET_TECHNICIAN_LIST = "/getTechnicianList";
export const UPDATE_CARD_STATUS = "/job-card/updateStatus/";
//reports

export const ORDER_REPORT = "report/getOrder";
export const PO_REPORT = "report/getPO";
export const JOB_CARD_REPORT = "report/getJobCard";

//dashboard
export const DASHBOARD_STATISTICS = "dashboard/statistics";
export const LIST_OF_TOP_CUSTOMERS = "dashboard/listOfTopCustomers";
export const GRAPH_OF_STATISTICS = "dashboard/graphOfStatistics";

export const JOB_CARD_REPORT_EXPORT = "/report/exportJobCard";
export const PO_REPORT_EXPORT = "/report/exportPo";
export const ORDER_REPORT_EXPORT = "/report/exportOrder";

export const FILE_UPLOAD = "/fileUploads";
export const DELETE_FILE = "deleteUploadedFile";

//store
export const CREATE_STORE = "store";
export const STORE = "store/";
export const LIST_OF_STORE = "store/list";
export const GET_STORE_LIST = "/getStoreList";

//UOM
export const LIST_OF_UOM = "product/listOfUom";

//Email and Invoice
export const HANDLE_SEND = "/invoice/sendInvoiceMail";
export const GEN_ORD_INVOICE = "/invoice/GenerateOrderInvoice";
export const GEN_PO_INVOICE = "/invoice/purchaseOrderInvoice";
export const GEN_GRN_INVOICE = "/invoice/grnInvoice";

//Finance-Quotation
export const QUOTATION = "finance-quotation";
export const VIEW_QUOTATION = "finance-quotation/quotation-details/";
export const VENDOR_DROP = "finance-quotation/vendorList";
export const PRODUCT_DROP = "finance-quotation/productList";
export const QUOTATION_LIST = "finance-quotation/quotationList";
export const QUOTATION_STATUS_EDIT = "finance-quotation/statusApproval/";
export const COUNT_PER_AMOUNT = "finance-quotation/countPerAmount";
export const COUNT_PER_GST = "finance-quotation/countGstAmount";
export const TOTAL_AMOUNT = "finance-quotation/countTotalAmountWithGst";
export const HSN_DROPDOWN = "hsn-sac/getHsnSac";
export const PRODUCT_RATE = "finance-quotation/updatedProductList";

//Work-order
export const WORK_ORDER = "work-order";
export const WORK_ORDER_EDIT = "work-order/";
export const WORK_ORDER_LIST = "work-order/listOfWorkOrder";
export const QUOTATION_DROPDOWN = "repair-order/listOfQuotationNo";
export const COUNT_GST = "work-order/getWorkOrderGst";
export const QUOTATION_WORK_ORDER =
  "repair-order/listOfQuotationNoForWorkOrder";
export const EDIT_WORK_ORDER_STATUS = "work-order/workOrderStatus/";

// Credit-Note
export const CREDIT_NOTE_LIST = "credit-note/list";
export const ADD_EDIT_CREDIT_NOTE = "credit-note";
export const TAX_INVOICE_DROPDOWN = "credit-note/listOfTaxInvoice";
export const TAX_INVOICE_DATA = "credit-note/taxInvoiceList/";

// Tax-Invoice
export const TAX_INVOICE_LIST = "tax-invoice/list";
export const ADD_EDIT_TAX_INVOICE = "tax-invoice";
export const WORK_ORDER_TAX_INVOICE =
  "repair-order/listOfWorkOrderNoForTaxInvocie";

//Proforma-invoice
export const PROFORMA_LIST = "proforma-invoice/list";
export const ADD_PROFORMA = "proforma-invoice";
export const PROFORMA_DETAIL = "proforma-invoice/";
export const WORK_ORDER_PROFORMA =
  "repair-order/listOfWorkOrderNoForProformaInvocie";

//PDF
export const QUOTATION_PDF = "invoice/quotation/";
export const TAX_INVOICE_PDF = "invoice/taxInvoice/";
export const PROFORMA_PDF = "invoice/proformaInvoice/";
export const PURCHASE_ORDER_PDF = "invoice/generatePurchaseOrderInvoice/";
